export enum tipoAcaoEnum {
  ACAO_GRUPO = 1,
  ACAO_PERMISSAO = 2,
  CADASTRO = 3,
  EDICAO = 4,
  VISUALIZAR = 5,
  CLONARDADOS = 6,
  ATIVAR_INATIVAR = 7,
  SELECIONAR = 8,
  EXCLUIR = 9,
  VER_MODAL_VALOR = 10,
  AUDITORIA = 11,
  PAGINACAO = 12,
  DOWNLOAD = 13,
  FILTRO = 14,
  REPROCESSAR = 15,
  REVERTER = 16,
}
